export default __webpack_public_path__ + "static/media/dfimag.2092a80b.png";